import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import TextInput from '../common/TextInput';
import LoadingSpinner from '../common/LoadingSpinner';
import useAPI from './useApi';
import Logo from '../assets/img/Kwenda-Logo.svg';
import styles from '../assets/css/auth.module.css';
import classNames from 'classnames';

function EmailConfirmation() {
  const [code, setCode] = useState('');
  const { state: params } = useLocation();

  const { status, errors, actions: { verifyOTP } } = useAPI();
  const submit = (e) => {
    e.preventDefault();
    return verifyOTP({ email: params.email, otp: code, fullName:params.fullName });
  };

  return (
    <div className={styles.auth_main}>
      <div className={styles.auth_form}>
        <div className={styles.auth_form_header}>
          <div>
            <h2>تأكيد رمز التحقق</h2>
            <p style={{ width: '70%' }}>
              أدخل رمز التحقق الذي تم ارساله الى بريدك الإلكتروني
            </p>
          </div>
          <Link to="../">
            <img className={styles.auth_logo} alt="Kwenda Logo" src={Logo} />
          </Link>
        </div>
        <form>
          <TextInput
            label="رمز التحقق"
            // type="number"
            placeholder="XXXXXX"
            value={code}
            onChange={(event) => setCode(event.target.value)}
            error={errors.message}
          />
          <button className={classNames('button', styles.button)} onClick={submit}>
            تأكيد رمز التحقق
            {status === 'submitting' && <LoadingSpinner />}
          </button>

          <Link to="../login">العودة الى تسجيل الدخول</Link>
        </form>
      </div>
    </div>
  );
}

export default EmailConfirmation;
